import { createFormSchema } from "./generalValidation";
import { PTF_SCHEMA, BTF_SCHEMA } from "../schemas/filings/taxSituationSchema";

const SERVICE_MAP = { PTF: PTF_SCHEMA, BTF: BTF_SCHEMA };

export function getTaxFilingSchemas({ service, schemaKey }) {
  const serviceSchema = SERVICE_MAP[service] || {};
  const sectionArray = serviceSchema?.[schemaKey] || [];
  const formSchemaForStep = { [schemaKey]: sectionArray };
  return createFormSchema(formSchemaForStep);
}
